import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
// const options = {role: ROLE.SUPER_ADMIN};
const options = {};

const path = "admin/temple-runner-booking"

export const TempleRunnerBookingList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const CompleteOrder = async (values) => {
    return await axiosInstance(options).post(`${path}/complete-order`, values);
}

export const TempleRunnerBookingDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}

export const TempleRunnerPujaImageUpload = async (values) => {
    return await axiosInstance(options).post(`${path}/puja-image-upload`, values);
}

export const TempleRunnerPujaImageList = async (bookingId) => {
  return await axiosInstance(options).get(`${path}/puja-image-list?booking_id=${bookingId}`);
};

export const TempleRunnerPujaImageDelete = async (bookingId, imageName) => {
  return await axiosInstance(options).delete(
    `${path}/puja-image-delete`,
    {
      data: {
        booking_id: bookingId,
        image_name: imageName,
      },
    }
  );
};